// https://developers.google.com/calendar/api/v3/reference/colors/get
// THESE COLORS PULLED MANUALLY TO MATCH MODERN COLOR SET

export const calendarColors = {
  calendar: {
    '1': {
      background: '#795548',
      foreground: '#1d1d1d',
    },
    '2': {
      background: '#e67c73',
      foreground: '#1d1d1d',
    },
    '3': {
      background: '#d50000',
      foreground: '#1d1d1d',
    },
    '4': {
      background: '#f4511e',
      foreground: '#1d1d1d',
    },
    '5': {
      background: '#ef6c00',
      foreground: '#1d1d1d',
    },
    '6': {
      background: '#f09300',
      foreground: '#1d1d1d',
    },
    '7': {
      background: '#009688',
      foreground: '#1d1d1d',
    },
    '8': {
      background: '#0b8043',
      foreground: '#1d1d1d',
    },
    '9': {
      background: '#7cb342',
      foreground: '#1d1d1d',
    },
    '10': {
      background: '#c0ca33',
      foreground: '#1d1d1d',
    },
    '11': {
      background: '#e4c441',
      foreground: '#1d1d1d',
    },
    '12': {
      background: '#f6bf26',
      foreground: '#1d1d1d',
    },
    '13': {
      background: '#33b679',
      foreground: '#1d1d1d',
    },
    '14': {
      background: '#039be5',
      foreground: '#1d1d1d',
    },
    '15': {
      background: '#4285f4',
      foreground: '#1d1d1d',
    },
    '16': {
      background: '#3f51b5',
      foreground: '#1d1d1d',
    },
    '17': {
      background: '#7986cb',
      foreground: '#1d1d1d',
    },
    '18': {
      background: '#b39ddb',
      foreground: '#1d1d1d',
    },
    '19': {
      background: '#616161',
      foreground: '#1d1d1d',
    },
    '20': {
      background: '#a79b8e',
      foreground: '#1d1d1d',
    },
    '21': {
      background: '#ad1457',
      foreground: '#1d1d1d',
    },
    '22': {
      background: '#d81b60',
      foreground: '#1d1d1d',
    },
    '23': {
      background: '#8e24aa',
      foreground: '#1d1d1d',
    },
    '24': {
      background: '#9e69af',
      foreground: '#1d1d1d',
    },
  },
  event: {
    '1': {
      background: '#7986cb',
      foreground: '#1d1d1d',
    },
    '2': {
      background: '#33b679',
      foreground: '#1d1d1d',
    },
    '3': {
      background: '#8e24aa',
      foreground: '#1d1d1d',
    },
    '4': {
      background: '#e67c73',
      foreground: '#1d1d1d',
    },
    '5': {
      background: '#f6bf26',
      foreground: '#1d1d1d',
    },
    '6': {
      background: '#f4511e',
      foreground: '#1d1d1d',
    },
    '7': {
      background: '#039be5',
      foreground: '#1d1d1d',
    },
    '8': {
      background: '#616161',
      foreground: '#1d1d1d',
    },
    '9': {
      background: '#3f51b5',
      foreground: '#1d1d1d',
    },
    '10': {
      background: '#0b8043',
      foreground: '#1d1d1d',
    },
    '11': {
      background: '#d50000',
      foreground: '#1d1d1d',
    },
  },
};
